export default "__VITE_ASSET__DoXv0OF8__"